module.exports = __webpack_public_path__ + "img/authorization-login.e8047ba8.svg";